/* ============================================================
   CHOMP — engine
   flavor picker · plan toggle (full swap) · bundle ladder ·
   functional cart · sticky ATC · faq · nav · marquee pause
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + n.toFixed(2).replace(/\.00$/, ''); };

  /* ---------------- data ---------------- */
  /* ---------------- products ----------------
     One engine, two products. Everything product-specific lives here; the rest
     of the file reads through PROD, so adding a line never means branching the
     ladder, cart or sticky-bar logic. A product with a single "flavor" simply
     renders no flavor row — applyFlavor still drives its accent and pack shot. */
  var PRODUCTS = {
    dental: {
      altName: 'dental finger wipes',
      unitsPerCan: 50,          /* supplier ships 50, not the 60 first assumed */
      unitWord: 'wipe',
      /* Two wipes a session, one per side of the mouth: dragging a single wipe
         across both sides just moves the plaque it lifted from one side to the
         other. Same reasoning as one pad per eye on the eye wipes. This halves
         how long a tub lasts, so every supply figure below follows from it. */
      perDay: 2,
      flavors: {
        minty: { name: 'Minty Fresh',   sub: 'Cool + classic',     ink: '#1FA97A', deep: '#14805C', tint: 'rgba(31,169,122,.10)', img: 'can-minty.webp' },
        pb:    { name: 'Peanut Butter', sub: 'Bribery, basically', ink: '#C98A2E', deep: '#9A6614', tint: 'rgba(201,138,46,.12)',  img: 'can-pb.webp' },
        plain: { name: 'Unscented',     sub: 'For fussy snoots',   ink: '#7C8B96', deep: '#55636D', tint: 'rgba(124,139,150,.12)', img: 'can-plain.webp' }
      },
      defaultFlavor: 'minty',
      bonuses: [[], ['ebook'], ['ebook', 'tracker']]
    },
    eye: {
      altName: 'eye wipes',
      /* 100 pads, one per eye per day, so a tub still covers 50 days — the same
         supply ladder as the dental line, which keeps the two carts coherent. */
      unitsPerCan: 100,
      unitWord: 'pad',
      perDay: 2,               /* one pad per eye */
      flavors: {
        gentle: { name: 'Gentle Daily', sub: 'Dogs + cats', ink: '#6E8BD6', deep: '#4C66AE', tint: 'rgba(110,139,214,.12)', img: 'eye-can.webp' }
      },
      defaultFlavor: 'gentle',
      bonuses: null
    }
  };

  /* Digital extras included with the bigger bundles. Rob's structure: nothing on
     the single tub, the guide on the 2-tub, both on the 3-tub — so the reason to
     size up is not only the per-wipe price.

     NOTE: no struck-through "value" is shown against these. We have never sold
     them, so any reference price would be invented — that is a false savings
     claim, and it is the kind the CMA/DMCCA singles out. If we ever list them
     for real, the price becomes quotable. */
  var BONUSES = {
    ebook:   { name: 'Fresh Breath in 30 Days', label: 'Free guide' },
    tracker: { name: '21-Day Routine Tracker',  label: 'Free printable' }
  };

  var PROD_KEY = (window.CHOMP_PRODUCT && PRODUCTS[window.CHOMP_PRODUCT]) ? window.CHOMP_PRODUCT : 'dental';
  var PROD = PRODUCTS[PROD_KEY];
  var FLAVORS = PROD.flavors;

  /* bump when regenerating imagery so browsers don't serve a stale pack shot */
  var IMG_V = '';

  /* pieces per canister, from the active product. Everything downstream
     (supply days, per-unit price, tier names) keys off this. */
  var WIPES_PER_CAN = PROD.unitsPerCan;

  var FREE_SHIP = 40;

  /* Tiers are SUPPLY DURATION for one dog, not dog count. Two wipes go in per
     session -- one per side of the mouth -- so a 50-wipe canister is 25 days and
     1/2/3 canisters are 25/50/75 days. Nothing below hardcodes those; they are
     derived, which is how the tier names survived both the 60->50 tub change and
     this one.

     Why it changed: the old dog-count tiers shipped on a fixed cadence that
     outran consumption — tubs pile up and people cancel (exactly what Rob
     described). Each tier now ships when its own supply runs out, so the
     delivery lands when the customer actually needs it.

     Each tier therefore has its OWN Loop cadence: 25 / 50 / 75 days (4/7/11 weeks). */
  var CADENCE_DAYS = 25;   /* fallback only — tiers carry their own `days` */

  /* Ladder shape is shared by both products so the two can never drift apart:
     three tiers of 1/2/3 canisters, each covering `unitsPerCan / perDay` days of
     use and shipping on its own cadence. Only the numbers differ per product. */
  var LADDER = [
    { id: 't1', cans: 1 },
    { id: 't2', cans: 2, pop: true },
    { id: 't3', cans: 3, best: true }
  ];

  function ladder(prices, wasList, saves) {
    return LADDER.map(function (b, i) {
      var days = Math.round(b.cans * PROD.unitsPerCan / PROD.perDay);
      /* The tier name IS the supply length — derived, never typed. Hardcoding it
         is how "7 Weeks" survived the tub going 60 -> 50 and again when usage
         went 1 -> 2 a day, each time claiming a duration the maths contradicted. */
      var weeks = Math.round(days / 7);
      return {
        id: b.id, cans: b.cans, name: weeks + ' Weeks', pop: b.pop, best: b.best,
        days: days,
        bonus: (PROD.bonuses && PROD.bonuses[i]) || [],
        price: prices[i], was: wasList[i], save: saves[i],
        meta: b.cans + ' × ' + PROD.unitsPerCan + ' ' + PROD.unitWord + 's · ' + days + ' days'
      };
    });
  }

  /* PRICES — dental is live and confirmed. Eye wipes mirror the same discount
     ladder (0/7/14% one-time, 20/26/31% subscribed) off a $27 single tub.
     EYE PRICING IS A PROPOSAL — confirm before this product goes live. */
  var PRICING = {
    dental: {
      sub: { prices: [24.36, 46.40, 63.51], was: [29, 58, 87], saves: ['Save 16%', 'Save 20%', 'Save 27%'] },
      otp: { prices: [29, 53.94, 74.82],    was: [null, 58, 87], saves: [null, 'Save 7%', 'Save 14%'] }
    },
    eye: {
      sub: { prices: [21.60, 40.18, 55.73], was: [27, 54, 81], saves: ['Save 20%', 'Save 26%', 'Save 31%'] },
      otp: { prices: [27, 50.22, 69.66],    was: [null, 54, 81], saves: [null, 'Save 7%', 'Save 14%'] }
    }
  };

  var PR = PRICING[PROD_KEY];
  var PLANS = {
    sub: { verb: 'Start my plan', note: '', tiers: ladder(PR.sub.prices, PR.sub.was, PR.sub.saves) },
    otp: { verb: 'Add to cart',
           note: 'One-time order · free shipping over ' + money(FREE_SHIP),
           tiers: ladder(PR.otp.prices, PR.otp.was, PR.otp.saves) }
  };

  /* How often THIS tier ships. `cadenceLabel` is attached by the Shopify adapter
     from the live Loop plan name so the page can never contradict what Loop will
     actually charge; in the static preview it is undefined and the tier's own
     interval is the truth. */
  function cadence(t) { return t.cadenceLabel || ((t.days || CADENCE_DAYS) + ' days'); }

  /* Resolve a runtime image path. The Shopify build replaces IMG_SRC with a
     lookup into a Liquid-generated map of file -> versioned CDN URL. It must
     keep asset_url's ?v= intact: without it the CDN pins the first upload and
     later edits to the canister art never reach anyone. */
  function IMG_SRC(file) { return (window.CHOMP_ASSETS && window.CHOMP_ASSETS[file]) || ('images/' + file); }

  var state = { flavor: PROD.defaultFlavor, plan: 'sub', tier: 't2', cart: [], drawer: false };

  /* The cart lived only in this object, so walking from the homepage to the PDP
     emptied it — which reads as a broken store. Shopify keeps the cart server-side,
     but the preview needs to behave the same way to be demoable.
     sessionStorage (not local) so it clears when the browser closes. */
  var STORE_KEY = 'chomp.v1';
  function save() {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({ cart: state.cart, flavor: state.flavor }));
    } catch (e) { /* private mode / quota — the cart just won't persist */ }
  }
  function restore() {
    try {
      var raw = sessionStorage.getItem(STORE_KEY);
      if (!raw) return;
      var d = JSON.parse(raw);
      if (d && Object.prototype.hasOwnProperty.call(FLAVORS, d.flavor)) state.flavor = d.flavor;
      if (d && Array.isArray(d.cart)) {
        state.cart = d.cart.filter(function (l) {
          return l && typeof l.price === 'number' && typeof l.qty === 'number' && l.qty > 0;
        });
      }
    } catch (e) { /* corrupt payload — start empty rather than throw */ }
  }

  /* ---------------- flavor: recolour the page ---------------- */
  function applyFlavor() {
    var f = FLAVORS[state.flavor];
    var r = document.documentElement;
    r.style.setProperty('--pop', f.ink);
    r.style.setProperty('--pop-deep', f.deep);
    r.style.setProperty('--pop-tint', f.tint);
    $$('.flav').forEach(function (el) {
      var on = el.dataset.flavor === state.flavor;
      el.setAttribute('aria-checked', on);
      el.tabIndex = on ? 0 : -1;   /* roving tabindex — one stop per group */
    });
    $$('[data-flavor-name]').forEach(function (el) { el.textContent = f.name; });

    /* every canister image on the page follows the selected flavor.
       Exception: on the PDP the main image only follows when the canister
       thumb is the active one — otherwise we'd yank the user off the photo
       they were actually looking at. */
    var canThumb = $('.pdp-thumb[data-thumb="can"]');
    var canThumbActive = !canThumb || canThumb.classList.contains('is-active');
    $$('[data-can-img]').forEach(function (el) {
      if (el.id === 'pdpMain' && !canThumbActive) return;
      el.src = IMG_SRC(f.img);
      if (el.id !== 'thumbCan') el.alt = 'CHOMP ' + PROD.altName + ' canister — ' + f.name;
    });
  }

  /* ---------------- bundle ladder ---------------- */
  function renderTiers() {
    var plan = PLANS[state.plan];
    var host = $('#tiers');
    if (!host) return;
    var fimg = IMG_SRC(FLAVORS[state.flavor].img);
    host.innerHTML = plan.tiers.map(function (t) {
      /* multipack thumbnails = real product shots, one per canister in the tier */
      /* width/height are required even on CSS-sized images — without an intrinsic
         ratio the browser reserves no space and the ladder reflows on image load (CLS). */
      var fan = '<div class="fan n' + t.cans + '">' +
        new Array(t.cans + 1).join('<img src="' + fimg + '" alt="" loading="lazy" width="1024" height="1024">') + '</div>';
      /* price-per-unit on multi-quantity is Baymard's single biggest PDP gap (81% of
         sites fail it). Show cost per wipe on EVERY tier, not just multipacks. */
      var perWipe = Math.round((t.price / (t.cans * WIPES_PER_CAN)) * 100);
      var per = '<span class="meta">' + perWipe + '¢ per ' + PROD.unitWord +
        (t.cans > 1 ? ' · ' + money(t.price / t.cans) + ' a can' : '') + '</span>';
      var tag = t.pop ? '<span class="pop-tag">Most popular</span>'
              : t.best ? '<span class="pop-tag best">Best value</span>' : '';
      /* Included digital extras, listed under the tier they come with. No
         struck-through value — see the note on BONUSES. */
      var bonus = (t.bonus || []).map(function (k) {
        var b = BONUSES[k];
        return !b ? '' : '<span class="tier-bonus">' +
          '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l4 4 10-10"/></svg>' +
          '<b>' + b.label + ':</b> ' + b.name + '</span>';
      }).join('');

      return '<div class="tier" role="radio" tabindex="' + (t.id === state.tier ? '0' : '-1') +
        '" data-tier="' + t.id + '" aria-checked="' + (t.id === state.tier) + '">' +
        tag +
        '<div class="tier-main">' + fan +
        '<div class="mid"><b>' + t.name + '</b><span class="meta">' + t.meta + '</span>' + per +
        (t.save ? '<span class="save">' + t.save + '</span>' : '') + '</div>' +
        /* red only when this tier genuinely carries a was-price */
        '<div class="right"><div class="pm tabular' + (t.was ? ' is-sale' : '') + '">' + money(t.price) +
        (state.plan === 'sub' ? '<small> /' + cadence(t) + '</small>' : '') + '</div>' +
        (t.was ? '<div class="was tabular">' + money(t.was) + '</div>' : '') + '</div>' +
        '<span class="radio" aria-hidden="true"></span></div>' +
        (bonus ? '<div class="tier-bonuses">' + bonus + '</div>' : '') +
        '</div>';
    }).join('');
  }

  function currentTier() {
    return PLANS[state.plan].tiers.filter(function (t) { return t.id === state.tier; })[0];
  }

  /* the toggle must swap EVERYTHING — prices, verb, note, sticky bar */
  function renderBuy() {
    /* policy/contact pages ship the same header, footer and cart drawer but no
       buy box — bail out before touching the toggle or the whole init dies and
       takes the cart with it. */
    var plan = PLANS[state.plan], t = currentTier();
    renderTiers();
    var ps = $('#planSub'), po = $('#planOtp');
    if (!ps || !po) return;
    ps.setAttribute('aria-pressed', state.plan === 'sub');
    po.setAttribute('aria-pressed', state.plan === 'otp');
    var atc = $('#mainAtc');
    if (atc) atc.textContent = plan.verb + ' — ' + money(t.price);
    var note = $('#buyNote');
    /* notePending is set by the Shopify adapter when Loop has no plans live yet */
    if (note) note.innerHTML = (state.plan === 'sub')
      ? (PLANS.sub.notePending || 'Ships every ' + cadence(t) + ' · skip or cancel anytime')
      : plan.note;
    syncSticky();
  }

  function syncSticky() {
    var t = currentTier(), f = FLAVORS[state.flavor];
    var nm = $('#sbName'), pr = $('#sbPrice'), bt = $('#sbBtn');
    if (nm) nm.textContent = t.name + ' · ' + f.name;
    if (pr) {
      pr.textContent = money(t.price) + (state.plan === 'sub' ? ' · every ' + cadence(t) : ' · one-time');
      pr.classList.toggle('is-sale', !!t.was);
    }
    if (bt) bt.textContent = 'Add — ' + money(t.price);
  }

  /* ---------------- cart (functional state machine) ---------------- */
  function addToCart() {
    var t = currentTier(), f = FLAVORS[state.flavor];
    /* product is part of the key: two products can share a tier id, and without
       it a dental tier and an eye tier would collapse into one cart line. */
    var key = PROD_KEY + '|' + state.plan + '|' + state.tier + '|' + state.flavor;
    var found = state.cart.filter(function (l) { return l.key === key; })[0];
    if (found) { found.qty += 1; }
    else {
      state.cart.push({
        key: key, qty: 1, plan: state.plan, flavor: state.flavor, product: PROD_KEY,
        name: t.name, flavorName: f.name, meta: t.meta, days: t.days, cadenceLabel: t.cadenceLabel,
        bonus: (t.bonus || []).slice(),
        price: t.price, was: t.was, cans: t.cans
      });
    }
    renderCart();
    openDrawer();
  }

  function renderCart() {
    var body = $('#cartBody'), foot = $('#cartFoot');
    if (!body) return;
    var count = state.cart.reduce(function (a, l) { return a + l.qty; }, 0);
    var total = state.cart.reduce(function (a, l) { return a + l.price * l.qty; }, 0);
    var wasTotal = state.cart.reduce(function (a, l) { return a + (l.was || l.price) * l.qty; }, 0);
    var saved = wasTotal - total;

    var badge = $('#cartCount');
    if (badge) { badge.textContent = count; badge.style.display = count ? 'grid' : 'none'; }

    save();

    if (!state.cart.length) {
      body.innerHTML = '<div class="empty"><svg viewBox="0 0 24 24"><path d="M6 7h12l1 13H5L6 7z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>' +
        '<b>Nothing in here yet.</b><p style="margin-top:6px;font-size:.88rem">Your dog is judging you.</p></div>';
      foot.innerHTML = '';
      return;
    }

    var meter = Math.min(100, (total / FREE_SHIP) * 100);
    var shipMsg = total >= FREE_SHIP
      ? 'Free shipping unlocked'
      : money(FREE_SHIP - total) + ' away from free shipping';

    body.innerHTML =
      '<div class="ship-bar">' + shipMsg + '<div class="meter"><i style="width:' + meter + '%"></i></div></div>' +
      state.cart.map(function (l, i) {
        return '<div class="line">' +
          '<div class="line-img"><svg viewBox="0 0 26 34" aria-hidden="true"><rect x="2" y="6" width="22" height="26" rx="3" fill="none" stroke="#16150F" stroke-width="2.5"/><rect x="6" y="1" width="14" height="6" rx="2" fill="none" stroke="#16150F" stroke-width="2.5"/></svg></div>' +
          '<div class="line-mid"><b>' + l.name + '</b>' +
          '<span class="meta">' + l.flavorName + ' · ' + l.meta + '</span>' +
          '<span class="meta">' + (l.plan === 'sub' ? 'Subscription · every ' + cadence(l) : 'One-time') + '</span>' +
          (l.bonus || []).map(function (k) {
            return BONUSES[k] ? '<span class="meta line-bonus">+ ' + BONUSES[k].name + '</span>' : '';
          }).join('') +
          '<span class="qty"><button data-q="-" data-i="' + i + '" aria-label="Decrease quantity">−</button>' +
          '<span class="tabular">' + l.qty + '</span>' +
          '<button data-q="+" data-i="' + i + '" aria-label="Increase quantity">+</button></span>' +
          '</div>' +
          '<div class="line-right"><div class="p tabular' + (l.was && l.was > l.price ? ' is-sale' : '') + '">' + money(l.price * l.qty) + '</div>' +
          '<button class="rm" data-rm="' + i + '">Remove</button></div>' +
          '</div>';
      }).join('');

    foot.innerHTML =
      (saved > 0 ? '<div class="saved"><span>You\'re saving</span><span class="tabular">' + money(saved) + '</span></div>' : '') +
      '<div class="tot"><span class="lbl">Total</span><span class="val tabular">' + money(total) + '</span></div>' +
      '<button class="btn btn-lg" id="checkoutBtn">Checkout</button>' +
      '<p style="text-align:center;font-size:.74rem;color:var(--ink-soft);margin-top:10px">Free tracked shipping over ' + money(FREE_SHIP) + ' · 60-day happy-dog promise</p>';
  }

  function openDrawer() {
    state.drawer = true;
    $('#drawer').classList.add('is-open');
    $('#scrim').classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    state.drawer = false;
    $('#drawer').classList.remove('is-open');
    $('#scrim').classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ---------------- events ---------------- */
  document.addEventListener('click', function (e) {
    var el;

    /* flavor change re-renders the ladder too, so the multipack thumbnails
       show the flavor you actually picked */
    if ((el = e.target.closest('.flav'))) { state.flavor = el.dataset.flavor; applyFlavor(); renderBuy(); return; }
    if ((el = e.target.closest('.pdp-thumb'))) {
      var picked = el;
      $$('.pdp-thumb').forEach(function (t) { t.classList.toggle('is-active', t === picked); });
      var main = $('#pdpMain'), src = picked.dataset.thumb;
      if (main) main.src = (src === 'can') ? IMG_SRC(FLAVORS[state.flavor].img) : src;
      return;
    }
    if ((el = e.target.closest('.tier'))) { state.tier = el.dataset.tier; renderBuy(); return; }
    if ((el = e.target.closest('#planSub'))) { state.plan = 'sub'; renderBuy(); return; }
    if ((el = e.target.closest('#planOtp'))) { state.plan = 'otp'; renderBuy(); return; }
    /* [data-buy] is a SCROLL link, never an add-to-cart. It used to share a branch
       with the ATC buttons and fall through when #buy was missing, so on the PDP
       "Pick your flavor" silently added an item instead of scrolling. Handled on
       its own now, and it returns whether or not a target is found. */
    if (e.target.closest('[data-buy]')) {
      e.preventDefault();
      var buy = $('#buy') || $('.pdp-buy') || $('#tiers');
      if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    if (e.target.closest('#mainAtc') || e.target.closest('#sbBtn')) { addToCart(); return; }
    if ((el = e.target.closest('[data-q]'))) {
      var line = state.cart[+el.dataset.i];
      if (!line) return;
      line.qty += (el.dataset.q === '+' ? 1 : -1);
      if (line.qty < 1) state.cart.splice(+el.dataset.i, 1);
      renderCart(); return;
    }
    if ((el = e.target.closest('[data-rm]'))) { state.cart.splice(+el.dataset.rm, 1); renderCart(); return; }
    if (e.target.closest('[data-cart-open]')) { renderCart(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('#scrim')) { closeDrawer(); return; }
    if (e.target.closest('#checkoutBtn')) { alert('Demo build — checkout wires to Shopify on the live theme.'); return; }
    if (e.target.closest('#burger')) { $('#mnav').classList.add('is-open'); document.body.style.overflow = 'hidden'; return; }
    if (e.target.closest('[data-mnav-close]')) { $('#mnav').classList.remove('is-open'); document.body.style.overflow = ''; return; }
    if ((el = e.target.closest('.faq-q'))) {
      var item = el.parentElement, open = item.classList.toggle('is-open');
      var a = $('.faq-a', item);
      a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
      el.setAttribute('aria-expanded', open);
      return;
    }
  });

  /* Keyboard on radio-style tiers + flavors.
     role="radio" carries an expectation: arrow keys move the selection and only the
     checked radio is in the tab order (roving tabindex). Enter/Space alone left the
     group tabbable three times over and unreachable by arrow. */
  function rove(group) {
    $$(group).forEach(function (el) {
      el.tabIndex = el.getAttribute('aria-checked') === 'true' ? 0 : -1;
    });
  }
  function syncRoving() { rove('.flav'); rove('.tier'); }

  document.addEventListener('keydown', function (e) {
    var el = e.target.closest('.tier') || e.target.closest('.flav');
    if (!el) return;
    var isTier = el.classList.contains('tier');
    var group = $$(isTier ? '.tier' : '.flav');
    var i = group.indexOf(el);

    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      el.click();
      syncRoving();
      return;
    }
    var step = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
    if (step === undefined && e.key !== 'Home' && e.key !== 'End') return;
    e.preventDefault();
    var next = e.key === 'Home' ? 0
             : e.key === 'End' ? group.length - 1
             : (i + step + group.length) % group.length;
    group[next].click();
    /* the tier list is re-rendered on selection, so re-query before focusing */
    var fresh = $$(isTier ? '.tier' : '.flav')[next];
    syncRoving();
    if (fresh) fresh.focus();
  });

  /* marquee pause — WCAG 2.2.2 */
  var mq = $('#announce'), mqBtn = $('#mqPause');
  if (mq && mqBtn) {
    mqBtn.addEventListener('click', function () {
      var on = mq.classList.toggle('paused');
      mqBtn.setAttribute('aria-pressed', on);
      mqBtn.setAttribute('aria-label', on ? 'Resume announcements' : 'Pause announcements');
      mqBtn.textContent = on ? '▶' : '❙❙';
    });
  }

  /* ---------------- reveals ----------------
     JS owns the hidden start state (html.js in CSS). Multiple safety nets so
     content can never be stranded at opacity:0. */
  function revealAll() { $$('.reveal').forEach(function (n) { n.classList.add('in'); }); }

  if ('IntersectionObserver' in window && !document.hidden) {
    var ro = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); ro.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (n) { ro.observe(n); });
    /* backstop: if callbacks never arrive (throttled tab, prerender), show everything */
    setTimeout(function () {
      if (!document.querySelector('.reveal.in')) revealAll();
    }, 1600);
  } else {
    revealAll();
  }
  /* a tab that was hidden at load gets everything shown the moment it appears */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && !document.querySelector('.reveal.in')) revealAll();
  });

  /* ---------------- sticky ATC ----------------
     scroll-driven (not IO): reliable in background tabs, bfcache and prerender */
  (function () {
    var anchor = $('#mainAtc'), bar = $('#stickyAtc');
    if (!anchor || !bar) return;
    var ticking = false;
    function update() {
      ticking = false;
      var past = anchor.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('show', past);
      bar.setAttribute('aria-hidden', past ? 'false' : 'true');
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  })();

  /* carousel arrows — thumbnail rail only.
     Built in JS rather than markup because the Shopify build regenerates the
     thumbs block from product.media, so anything hardcoded inside it is lost.
     Wrapping at runtime also keeps the arrows OUTSIDE the scroll container,
     which is the only way they can stay put while the track moves. */
  function buildArrows(track) {
    if (!track || track.parentNode.classList.contains('rail')) return;

    var rail = document.createElement('div');
    rail.className = 'rail';
    track.parentNode.insertBefore(rail, track);
    rail.appendChild(track);

    function arrow(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rail-arrow rail-' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' +
        (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
      rail.appendChild(b);
      return b;
    }
    var prev = arrow('prev', 'Previous images');
    var next = arrow('next', 'Next images');

    /* step by one thumb + gap, so a press always lands on a snap point */
    function step() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    /* Smooth scrolling is inert in a throttled or hidden document — a background
       tab, a prerender, or an embedded preview pane, where rAF never runs. The
       animation simply never starts and the arrow appears dead. So aim at an
       explicit clamped target, then verify it actually moved and assign directly
       if it did not. A control that silently does nothing is the worst outcome. */
    function go(d) {
      var max = track.scrollWidth - track.clientWidth;
      var target = Math.max(0, Math.min(max, track.scrollLeft + d * step()));
      var from = track.scrollLeft;
      try { track.scrollTo({ left: target, behavior: 'smooth' }); } catch (e) { }
      setTimeout(function () {
        if (Math.abs(track.scrollLeft - from) < 1) track.scrollLeft = target;
        sync();
      }, 60);
    }
    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });

    /* grey out at the ends rather than hiding — a control that vanishes makes
       the row jump, and the rail is centred on the gallery */
    function sync() {  // eslint-disable-line no-inner-declarations
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= max - 2;
      rail.classList.toggle('is-scrollable', max > 4);
      prev.disabled = atStart;
      next.disabled = atEnd;
    }
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    /* images load late and change scrollWidth, so re-check once they settle */
    $$('img', track).forEach(function (im) {
      if (!im.complete) im.addEventListener('load', sync, { once: true });
    });
    setTimeout(sync, 300);
    sync();
  }
  buildArrows($('.pdp-thumbs'));

  /* carousel dots */
  /* dots count only VISIBLE slides — the review wall hides 7 cards until expanded,
     so a naive child count would render dots that lead nowhere. */
  function buildDots(track) {
    var dots = $('#' + track.dataset.carousel);
    if (!dots) return;
    var n = $$(':scope > *:not([hidden])', track).length;
    dots.innerHTML = new Array(n + 1).join('<i></i>');
    var marks = $$('i', dots);
    if (marks[0]) marks[0].className = 'is-active';
    track._marks = marks;
  }
  $$('[data-carousel]').forEach(function (track) {
    buildDots(track);
    track.addEventListener('scroll', function () {
      var marks = track._marks || [];
      if (!marks.length) return;
      var max = track.scrollWidth - track.clientWidth;
      var i = max > 4 ? Math.round((track.scrollLeft / max) * (marks.length - 1)) : 0;
      marks.forEach(function (m, j) { m.classList.toggle('is-active', j === i); });
    }, { passive: true });
  });

  /* email capture. Named field + real validation + a visible result — the failure
     mode to avoid is a form that silently swallows the submit and looks broken.
     TODO before launch: POST to Klaviyo (list id + double opt-in) instead of the
     local success state. */
  var signup = $('#signupForm');
  if (signup) {
    var emailField = $('#signupEmail'), signupMsg = $('#signupMsg');
    signup.addEventListener('submit', function (e) {
      /* Same trap as the contact form: an unconditional preventDefault meant the
         form validated, said "You're in", and posted nowhere. Only block on a
         failure; when it is valid and has an action, let Shopify have it. */
      var v = (emailField.value || '').trim();
      var ok = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      emailField.setAttribute('aria-invalid', ok ? 'false' : 'true');
      signupMsg.classList.toggle('is-err', !ok);
      if (!ok) {
        e.preventDefault();
        signupMsg.textContent = 'That email doesn’t look right — mind checking it?';
        emailField.focus();
        return;
      }
      /* real form on the storefront -> let it post; preview -> fake it */
      if (signup.getAttribute('action')) return;
      e.preventDefault();
      signupMsg.textContent = 'You’re in. Check your inbox to confirm.';
      signup.querySelector('.foot-sign-field').style.display = 'none';
    });
    emailField.addEventListener('input', function () {
      if (emailField.getAttribute('aria-invalid') === 'true') {
        emailField.setAttribute('aria-invalid', 'false');
        signupMsg.textContent = '';
        signupMsg.classList.remove('is-err');
      }
    });
  }

  /* contact form. Per-field validation, errors announced via role=alert, focus moved
     to the first offender. The failure mode being avoided: a form that cancels its own
     submit and gives the user nothing back, which reads as a broken store.
     TODO before launch: POST to the helpdesk / Shopify contact endpoint. */
  var cform = $('#contactForm');
  if (cform) {
    var FIELDS = [
      { el: '#cfName',  err: '#errName',  msg: 'Please tell us your name.',      test: function (v) { return v.length > 0; } },
      { el: '#cfEmail', err: '#errEmail', msg: 'That email doesn’t look right.', test: function (v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); } },
      { el: '#cfMsg',   err: '#errMsg',   msg: 'Add a message so we know what you need.', test: function (v) { return v.length > 3; } }
    ];
    cform.addEventListener('submit', function (e) {
      /* Do NOT preventDefault unconditionally. On Shopify this form is wrapped in
         {% form 'contact' %} and must post natively — blocking it was why the
         contact form silently did nothing. Only block on a validation failure,
         and only fake the confirmation when there is no action to post to
         (i.e. the static preview). */
      var firstBad = null;
      FIELDS.forEach(function (f) {
        var el = $(f.el), errEl = $(f.err), ok = f.test((el.value || '').trim());
        el.setAttribute('aria-invalid', ok ? 'false' : 'true');
        errEl.textContent = ok ? '' : f.msg;
        if (!ok && !firstBad) firstBad = el;
      });
      var out = $('#cformMsg');
      if (firstBad) {
        e.preventDefault();
        out.className = 'cform-msg is-err';
        out.textContent = 'Nearly — check the highlighted fields.';
        firstBad.focus();
        return;
      }
      /* valid: on the storefront let it submit to Shopify and reload with
         form.posted_successfully. Only the preview (no action) fakes it. */
      if (cform.getAttribute('action')) return;
      e.preventDefault();
      out.className = 'cform-msg';
      out.textContent = 'Message sent. We’ll come back to you within one working day.';
      cform.querySelectorAll('.cfield, button[type=submit]').forEach(function (n) { n.style.display = 'none'; });
    });
    FIELDS.forEach(function (f) {
      var el = $(f.el);
      el.addEventListener('input', function () {
        if (el.getAttribute('aria-invalid') === 'true' && f.test((el.value || '').trim())) {
          el.setAttribute('aria-invalid', 'false');
          $(f.err).textContent = '';
        }
      });
    });
  }

  /* expand the review wall — keeps the page short by default without hiding the
     negatives (the 3★ is inside the first six on purpose). */
  var moreBtn = $('#moreReviews');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var wall = $('.wall'), hiddenCards = $$('[data-more]', wall);
      if (!hiddenCards.length) return;
      hiddenCards.forEach(function (c) { c.removeAttribute('hidden'); c.classList.add('in'); });
      buildDots(wall);
      moreBtn.setAttribute('aria-expanded', 'true');
      moreBtn.remove();
    });
  }

  /* ---------------- delivery estimate (geolocated) ----------------
     Times confirmed by Kevin 14 Aug 2026: 8–12 working days total, order to
     doorstep, across all five markets we ship to (UK / US / CA / AU / NZ).
     One working day of that is processing. Update here if fulfilment changes —
     the PDP bar, its modal, the shipping page and the FAQ must all agree. */
  var SHIP_EST = {
    US: { name: 'the United States', proc: '1 working day', transit: '7–11 days', total: '8–12 working days' },
    GB: { name: 'the United Kingdom', proc: '1 working day', transit: '7–11 days', total: '8–12 working days' },
    CA: { name: 'Canada',             proc: '1 working day', transit: '7–11 days', total: '8–12 working days' },
    AU: { name: 'Australia',          proc: '1 working day', transit: '7–11 days', total: '8–12 working days' },
    NZ: { name: 'New Zealand',        proc: '1 working day', transit: '7–11 days', total: '8–12 working days' }
  };
  var SHIP_FALLBACK = { name: 'your country', proc: '1 working day', transit: '7–11 days', total: '8–12 working days' };

  var shipBarTxt = $('#shipEstText');
  if (shipBarTxt) {
    function applyShip(code, countryName) {
      var e = SHIP_EST[code] || SHIP_FALLBACK;
      var label = e === SHIP_FALLBACK && countryName ? countryName : e.name;
      shipBarTxt.textContent = 'Ships to ' + label.replace(/^the /i, '') + ' in ' + e.total;
      var set = function (id, v) { var el = $(id); if (el) el.textContent = v; };
      set('#shipModalCountry', label);
      set('#shipModalProc', e.proc);
      set('#shipModalTransit', e.transit);
      set('#shipModalTotal', e.total);
      set('#shipModalNote', 'Typical times to ' + label.replace(/^the /i, '') +
        ', not a guarantee. Customs and peak periods can add a few days — you get tracking either way.');
    }
    applyShip(null, null);   /* render the fallback immediately, never an empty bar */

    /* Shopify knows the country server-side; only fall back to a network call
       when it does not (e.g. the static preview). */
    var shopCountry = (window.Shopify && window.Shopify.country) || null;
    if (shopCountry) {
      applyShip(shopCountry, null);
    } else {
      fetch('https://ipapi.co/json/')
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.country_code) applyShip(d.country_code, d.country_name); })
        .catch(function () { /* keep the fallback text */ });
    }

    /* modal */
    var shipModal = $('#shipModal');
    var openM = function (m) { if (m) { m.classList.add('is-open'); document.body.style.overflow = 'hidden'; } };
    var closeM = function (m) {
      if (m) m.classList.remove('is-open');
      if (!$('.modal-ov.is-open')) document.body.style.overflow = '';
    };
    var ib = $('#shipInfoBtn'); if (ib) ib.addEventListener('click', function () { openM(shipModal); });
    var ix = $('#shipModalClose'); if (ix) ix.addEventListener('click', function () { closeM(shipModal); });
    $$('.modal-ov').forEach(function (m) {
      m.addEventListener('click', function (e) { if (e.target === m) closeM(m); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') $$('.modal-ov.is-open').forEach(closeM);
    });
  }

  /* Page-level hook, used by the quiz. It sets state and re-renders through the
     SAME functions the buy box uses. On Shopify the adapter has reassigned those
     bindings before anything can call this, so a quiz pick gets the live price in
     the visitor's currency, the live Loop plan and the real cart drawer — there is
     no second price ladder to drift. Call it on or after DOMContentLoaded: section
     scripts sit above chomp.js in the document and run before it. */
  window.CHOMP = {
    select: function (o) {
      o = o || {};
      if (o.flavor && FLAVORS[o.flavor]) state.flavor = o.flavor;
      if (o.plan === 'sub' || o.plan === 'otp') state.plan = o.plan;
      if (o.tier && PLANS[state.plan].tiers.some(function (t) { return t.id === o.tier; })) state.tier = o.tier;
      applyFlavor();
      renderBuy();
    },
    flavorName: function (k) { return FLAVORS[k] ? FLAVORS[k].name : ''; },
    unitsPerCan: PROD.unitsPerCan,
    perDay: PROD.perDay
  };

  /* ============================================================
     SHOPIFY ADAPTER  (appended by build-theme.py — not in the preview)

     The preview engine keeps its own cart in memory. On the storefront Shopify
     owns the cart, so the three functions that touch it are reassigned here.
     `function foo(){}` creates a mutable binding, so this overrides them without
     editing a line of the UI code above.

     Ladder prices are hydrated from the real product data, which means changing a
     price in Shopify admin changes the storefront. Selling plans appear on their
     own once the Loop plans exist; until then the subscribe toggle falls back to
     one-time pricing rather than showing a plan that cannot be purchased.
     ============================================================ */

  var SHOP_DATA = (function () {
    var el = document.getElementById('chomp-product-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  })();

  if (SHOP_DATA) {
    /* The storefront talks in supply length ("7 Weeks") because that is the
       offer's angle, but Shopify's option values are literal ("2 Canisters") so
       cart, checkout and order emails read sensibly. This is the join between the two — if the
       Shopify option values are ever renamed again, update it here. */
    var SIZE_BY_TIER = { t1: '1 Canister', t2: '2 Canisters', t3: '3 Canisters' };
    var FLAVOR_BY_KEY = { minty: 'Minty Fresh', pb: 'Peanut Butter', plain: 'Unscented' };
    var CANS = { t1: 1, t2: 2, t3: 3 };

    /* The two products do not share an option order — the dental wipes are
       Flavor + Pack size, the eye wipes are Pack size only. Resolve each axis by
       NAME so neither product depends on which slot Shopify put it in. A product
       with no flavour axis reports flavourIdx -1, and every variant then matches
       on size alone. */
    var OPT_NAMES = SHOP_DATA.optionNames || [];
    function optIndex(re) {
      for (var i = 0; i < OPT_NAMES.length; i++) if (re.test(OPT_NAMES[i])) return i;
      return -1;
    }
    var SIZE_IDX = optIndex(/size|pack/i);
    var FLAVOR_IDX = optIndex(/flavou?r/i);
    function optOf(v, idx) { return idx < 0 ? null : (v.options || [])[idx]; }

    /* Units: the engine works in DOLLARS (its PLANS data, the per-wipe maths, the
       tier labels). Shopify's API works in CENTS. Convert once at the boundary
       rather than overriding money() — overriding it meant hydrate() divided by
       100 and money() divided again, rendering $29.00 as $0.29. */
    function centsToMoney(n) { return money(n / 100); }

    function variantById(id) {
      return SHOP_DATA.variants.filter(function (v) { return v.id === id; })[0] || null;
    }

    function variantFor(tierId, flavorKey) {
      var size = SIZE_BY_TIER[tierId], flav = FLAVOR_BY_KEY[flavorKey];
      return SHOP_DATA.variants.filter(function (v) {
        if (SIZE_IDX >= 0 && optOf(v, SIZE_IDX) !== size) return false;
        /* no flavour axis on this product — size alone identifies the variant */
        if (FLAVOR_IDX < 0) return true;
        return optOf(v, FLAVOR_IDX) === flav;
      })[0] || null;
    }

    /* Loop offers several delivery frequencies. Taking sellingPlans[0] would
       default everyone to the shortest one — shipping far more often than a
       canister lasts, which is exactly the over-shipping that makes people
       cancel. Each tier instead asks for its OWN interval (t.days = 25/50/75
       for 1/2/3 canisters: 50 wipes each, two a session) and we pick the closest plan,
       reading the interval out of the plan name (Liquid's selling_plan object
       does not expose delivery_policy). Falls back to the first plan if nothing
       parses — so if Loop's cadences are not yet 4/7/11 weeks, the ladder still
       renders, just on the nearest frequency Loop does offer. */
    function planDays(name) {
      var m = /(\d+)\s*(day|week|month)/i.exec(name || '');
      if (!m) return null;
      var n = parseInt(m[1], 10);
      var unit = m[2].toLowerCase();
      return unit === 'day' ? n : unit === 'week' ? n * 7 : n * 30;
    }

    function pickPlan(plans, targetDays) {
      if (!plans || !plans.length) return null;
      var target = targetDays || CADENCE_DAYS;
      var best = null, bestDelta = Infinity;
      plans.forEach(function (p) {
        var d = planDays(p.name);
        if (d == null) return;
        var delta = Math.abs(d - target);
        if (delta < bestDelta) { bestDelta = delta; best = p; }
      });
      return best || plans[0];
    }

    /* Hard-coded savings badges, per Kevin — one table, applied on every render.
       They were drifting: hydrate() rewrote price/was from Shopify but left
       `save` alone, and the sub tab ended up showing a mix of sub and one-time
       figures. Re-asserting them here every time makes that impossible.

       SUBSCRIBE assumes a flat 20% Loop plan on top of the one-time ladder,
       measured against the compare-at shown beside it ($29 / $58 / $87):
         1 Canister   $29.00 -> $23.20   = 20%
         2 Canisters  $53.94 -> $43.15   = 26%
         3 Canisters  $74.82 -> $59.86   = 31%
       If the Loop plan is not a flat 20%, change these three strings. */
    var SAVE_BADGES = {
      sub: { t1: 'Save 20%', t2: 'Save 26%', t3: 'Save 31%' },
      otp: { t1: null,       t2: 'Save 7%',  t3: 'Save 14%' }
    };

    /* rebuild PLANS from live Shopify pricing, keeping the tier copy */
    function hydrate() {
      var matched = 0;
      ['sub', 'otp'].forEach(function (planKey) {
        PLANS[planKey].tiers.forEach(function (t) {
          var v = variantFor(t.id, state.flavor);
          if (!v) return;
          matched++;
          t.variantId = v.id;
          t.available = v.available;
          if (planKey === 'otp') {
            t.price = v.price / 100;
            t.was = v.compareAt ? v.compareAt / 100 : null;
            t.sellingPlanId = null;
          } else {
            var plan = pickPlan(v.sellingPlans, t.days);
            if (plan) {
              t.price = plan.price / 100;
              /* Anchor against the variant's compare-at (qty x the $29 single-can
                 price), NOT Loop's allocation compare_at. Loop sets the latter to
                 the one-time price, which made tier 2 read "was $53.94 -> $43.15"
                 next to a "Save 26%" badge — visibly 20%, so badge and struck
                 price contradicted each other. Against the anchor the whole ladder
                 agrees: 29->23.20 = 20%, 58->43.15 = 26%, 87->59.86 = 31%. */
              t.was = (v.compareAt || v.price) / 100;
              t.sellingPlanId = plan.id;
              /* each size carries its own Loop frequency (4 / 8 / 12 weeks), so
                 the tier must state its own cadence, not a global one */
              t.cadenceLabel = (plan.name || '').replace(/^deliver\s+every\s+/i, '');
            } else {
              /* No Loop plan on this variant yet — show the one-time price rather
                 than a fiction. (Previously this copied the one-time tier's badge
                 onto the subscribe tier, which permanently overwrote it.) */
              t.price = v.price / 100;
              t.was = v.compareAt ? v.compareAt / 100 : null;
              t.sellingPlanId = null;
              t.cadenceLabel = null;
            }
          }
          t.cans = CANS[t.id];

          /* Hard-coded badge, re-asserted every render so nothing can drift into
             it. Suppressed when this tier has no real discount — a fixed "Save
             20%" beside an undiscounted price is a false savings claim, and while
             the Loop plans are still being set up that is exactly the state. */
          /* When the subscribe tab has no Loop plan yet it falls back to the
             ONE-TIME price above — so it must also fall back to the one-time
             badge. Reading the sub table there printed "Save 26%" over a price
             that was only 7% off, which is a false savings claim in the exact
             window before the plans go live. sellingPlanId is the signal. */
          var badgeKey = (planKey === 'sub' && !t.sellingPlanId) ? 'otp' : planKey;
          var badge = SAVE_BADGES[badgeKey][t.id];
          t.save = (badge && t.was && t.was > t.price) ? badge : null;
        });
      });
      /* If SIZE_BY_TIER stops matching Shopify's option values (someone renames
         them again), every lookup returns null and the ladder would quietly keep
         showing the hardcoded preview prices — wrong numbers that look right.
         Fail loudly instead: disable buying rather than sell at a stale price. */
      if (matched === 0) {
        var sizes = SHOP_DATA.variants.map(function (v) { return optOf(v, SIZE_IDX); }).filter(Boolean);
        console.error('CHOMP: no variant matched SIZE_BY_TIER. Shopify sizes are: ' +
          Array.from(new Set(sizes)).join(', ') + ' — update SIZE_BY_TIER in shopify-adapter.js');
        var atcBtn = document.getElementById('mainAtc');
        if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Temporarily unavailable'; }
        var noteEl = document.getElementById('buyNote');
        if (noteEl) noteEl.textContent = 'This product is being updated — please check back shortly.';
        return;
      }

      /* The engine prints the cadence itself, per tier, via cadence(t) — it reads
         the `cadenceLabel` hydrate() just attached from the live Loop plan name,
         so the page can never state a frequency Loop will not charge. All this
         has to add is the one case the engine cannot know about: Loop has no
         plans live yet, so there is no cadence to promise at all. */
      var anyPlan = SHOP_DATA.variants.some(function (v) { return (v.sellingPlans || []).length; });
      PLANS.sub.notePending = anyPlan
        ? null
        : 'Subscription plans are being set up — one-time pricing shown';
      var toggle = document.getElementById('planSub');
      if (toggle && !anyPlan) toggle.setAttribute('data-plans-pending', 'true');
    }
    hydrate();

    /* flavor changes swap which variants back the ladder */
    var _applyFlavor = applyFlavor;
    applyFlavor = function () { _applyFlavor(); hydrate(); };

    /* tier selection changes which Loop plan applies, so the cadence note has to
       be recomputed before the buy box re-renders */
    var _renderBuy = renderBuy;
    renderBuy = function () { hydrate(); _renderBuy(); };

    var shopCart = { items: [], total_price: 0, item_count: 0 };

    function refresh() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { shopCart = c; renderCart(); return c; });
    }

    addToCart = function () {
      var t = currentTier();
      if (!t || !t.variantId) { window.location.href = SHOP_DATA.handle ? '/products/' + SHOP_DATA.handle : '/'; return; }
      var body = { items: [{ id: t.variantId, quantity: 1 }] };
      if (state.plan === 'sub' && t.sellingPlanId) body.items[0].selling_plan = t.sellingPlanId;

      var btn = document.getElementById('mainAtc');
      var label = btn && btn.textContent;
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message || 'Add to cart failed'); });
          return r.json();
        })
        .then(function () { return refresh(); })
        .then(function () { openDrawer(); })
        .catch(function (err) {
          var note = document.getElementById('buyNote');
          if (note) note.textContent = err.message;
        })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    };

    /* drawer renders Shopify's cart, not the in-memory one */
    renderCart = function () {
      var body = document.querySelector('#cartBody'), foot = document.querySelector('#cartFoot');
      if (!body) return;
      var badge = document.querySelector('#cartCount');
      if (badge) { badge.textContent = shopCart.item_count; badge.style.display = shopCart.item_count ? 'grid' : 'none'; }

      if (!shopCart.items.length) {
        body.innerHTML = '<div class="empty"><svg viewBox="0 0 24 24"><path d="M6 7h12l1 13H5L6 7z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>' +
          '<b>Nothing in here yet.</b><p style="margin-top:6px;font-size:.88rem">Your dog is judging you.</p></div>';
        foot.innerHTML = '';
        return;
      }

      var total = shopCart.total_price;
      var threshold = SHOP_DATA.freeShipThreshold || 4000;
      /* Shopify's original_line_price only reflects discounts IT applied (scripts,
         automatic discounts) — it ignores compare_at_price, so on a compare-at
         ladder it equals final_line_price and the savings row never showed.
         Compare against the variant's real compare-at from SHOP_DATA instead. */
      var compareTotal = shopCart.items.reduce(function (a, l) {
        var v = variantById(l.variant_id);
        var unit = (v && v.compareAt) ? v.compareAt : l.original_price;
        return a + unit * l.quantity;
      }, 0);
      var saved = Math.max(0, compareTotal - total);
      var savedPct = compareTotal > 0 ? Math.round((saved / compareTotal) * 100) : 0;

      var meter = Math.min(100, (total / threshold) * 100);
      var shipMsg = total >= threshold ? 'Free shipping unlocked'
        : centsToMoney(threshold - total) + ' away from free shipping';

      /* Top-of-drawer bar. Two separate jobs, kept visually distinct:
         1. free-shipping progress (meter only while there is progress to make)
         2. what subscribing is actually saving them, stated in money and % */
      var shipBlock = total >= threshold
        ? '<div class="ship-bar is-done"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l4 4 10-10"/></svg>' +
          '<span>Free shipping unlocked</span></div>'
        : '<div class="ship-bar"><span>' + shipMsg + '</span>' +
          '<div class="meter"><i style="width:' + meter + '%"></i></div></div>';

      var subLines = shopCart.items.filter(function (l) { return l.selling_plan_allocation; }).length;
      var saveBlock = saved > 0
        ? '<div class="save-bar' + (subLines ? ' is-sub' : '') + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9"/><path d="M2 7h20v5H2z"/><path d="M12 21V7"/>' +
            '<path d="M12 7C10.5 7 8 6.5 8 4.5S10.5 3 12 7z"/><path d="M12 7c1.5 0 4-.5 4-2.5S13.5 3 12 7z"/></svg>' +
            '<span class="save-bar-txt">' +
              (subLines ? 'Subscribing saves you ' : 'You\'re saving ') +
              '<b>' + centsToMoney(saved) + '</b> (' + savedPct + '%)' +
            '</span>' +
          '</div>'
        : '';

      body.innerHTML = shipBlock + saveBlock +
        shopCart.items.map(function (l, i) {
          /* same reason as the savings total: compare against the variant's
             compare-at, not Shopify's original_line_price */
          var lv = variantById(l.variant_id);
          var lineWas = (lv && lv.compareAt) ? lv.compareAt * l.quantity : 0;
          var sale = lineWas > l.final_line_price;
          return '<div class="line">' +
            '<div class="line-img">' + (l.image ? '<img src="' + l.image + '" alt="" width="52" height="52">' : '') + '</div>' +
            '<div class="line-mid"><b>' + l.product_title + '</b>' +
            '<span class="meta">' + (l.variant_title || '') + '</span>' +
            '<span class="meta">' + (l.selling_plan_allocation ? l.selling_plan_allocation.selling_plan.name : 'One-time') + '</span>' +
            '<span class="qty"><button data-sq="-" data-k="' + l.key + '" aria-label="Decrease quantity">−</button>' +
            '<span class="tabular">' + l.quantity + '</span>' +
            '<button data-sq="+" data-k="' + l.key + '" aria-label="Increase quantity">+</button></span>' +
            '</div>' +
            '<div class="line-right"><div class="p tabular' + (sale ? ' is-sale' : '') + '">' + centsToMoney(l.final_line_price) + '</div>' +
            '<button class="rm" data-srm="' + l.key + '">Remove</button></div>' +
            '</div>';
        }).join('');

      foot.innerHTML =
        (saved > 0
          ? '<div class="saved"><span>You\'re saving</span><span class="tabular">' +
            centsToMoney(saved) + ' <em>(' + savedPct + '%)</em></span></div>'
          : '') +
        '<div class="tot"><span class="lbl">Total</span><span class="val tabular">' + centsToMoney(total) + '</span></div>' +
        '<button class="btn btn-lg" id="checkoutBtn">Checkout</button>' +
        '<p style="text-align:center;font-size:.74rem;color:var(--ink-soft);margin-top:10px">Free tracked shipping over ' +
        centsToMoney(threshold) + ' · 60-day happy-dog promise</p>';
    };

    /* quantity + remove + checkout run against Shopify */
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-sq]'), rm = e.target.closest('[data-srm]');
      var co = e.target.closest('#checkoutBtn');
      /* stopPropagation matters: the engine below still has the preview's demo
         alert() bound to #checkoutBtn, and preventDefault alone would let it fire. */
      if (co) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        window.location.href = '/checkout';
        return;
      }
      if (!q && !rm) return;
      e.preventDefault();
      var key = (q || rm).dataset.k || (q || rm).dataset.srm;
      var line = shopCart.items.filter(function (l) { return l.key === key; })[0];
      if (!line) return;
      var qty = rm ? 0 : line.quantity + (q.dataset.sq === '+' ? 1 : -1);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
      }).then(function (r) { return r.json(); })
        .then(function (c) { shopCart = c; renderCart(); });
    }, true);

    /* Deep links. An advertorial, an ad or an email that quotes a specific pack
       links here with ?variant=<id>. The engine boots on 2 canisters, subscribe,
       so before this every one of those links landed on a tier and a price the
       reader never clicked: "3 canisters, $74.99" opened on "$43.19".

       A bare ?variant= is Shopify's one-time purchase URL, so it opens the
       one-time tab at exactly the price that was quoted; add &selling_plan=<id>
       and it opens on subscribe instead. That is also what Merchant Center and
       catalog ads require — the landing price has to match the feed price.
       An id this product does not have changes nothing: the default tier is a
       better landing than a broken one. */
    (function applyDeepLink() {
      var q = new URLSearchParams(window.location.search);
      var v = variantById(parseInt(q.get('variant'), 10));
      if (!v) return;
      var size = optOf(v, SIZE_IDX), flav = optOf(v, FLAVOR_IDX);
      Object.keys(SIZE_BY_TIER).forEach(function (t) { if (SIZE_BY_TIER[t] === size) state.tier = t; });
      Object.keys(FLAVOR_BY_KEY).forEach(function (k) { if (FLAVOR_BY_KEY[k] === flav) state.flavor = k; });
      state.plan = q.get('selling_plan') ? 'sub' : 'otp';
      applyFlavor();
      renderBuy();
    })();

    refresh();
  }

  /* init */
  restore();
  applyFlavor();
  renderBuy();
  renderCart();
})();
